//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getPinnedMediaPositionMap = createSelector(
  (state: ICuralateStore) => state.galleries.data.items.pinnedItemsOrderedIds,
  (orderedCuids) => {
    return PojoMap.fromEntries(
      orderedCuids.map((cuid, idx) => [cuid, idx] as const),
    );
  },
);
